"use client";

import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Truck, MapPin, Clock, Shield } from "lucide-react";
export default function OurServices() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const services = [{
    icon: Truck,
    title: "Freight Coordination",
    description: "End-to-end management of your shipments with precision and reliability, ensuring goods move efficiently across all routes.",
    link: "#"
  }, {
    icon: MapPin,
    title: "Route Planning",
    description: "Optimized routing solutions that reduce transit time and costs while maintaining delivery schedules and cargo safety.",
    link: "#"
  }, {
    icon: Clock,
    title: "Real-Time Tracking",
    description: "Complete visibility into your shipments with live updates, allowing you to monitor progress and maintain transparency.",
    link: "#"
  }, {
    icon: Shield,
    title: "Compliance Management",
    description: "Expert handling of all documentation and regulatory requirements, ensuring your freight meets industry standards.",
    link: "#"
  }];
  const refs = [ref1, ref2, ref3, ref4];
  const visibilities = [isVisible1, isVisible2, isVisible3, isVisible4];
  return <section id="our-services" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            Our Services
          </h2>
          <p className="text-white text-lg max-w-2xl mx-auto">
            Comprehensive freight transportation solutions designed to keep your business moving forward
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} ref={refs[i]} className="transition-all duration-200 ease-out" style={{
            opacity: visibilities[i] ? 1 : 0,
            transform: visibilities[i] ? "translateY(0)" : "translateY(10px)",
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full hover:shadow-medium transition-shadow duration-200 border border-border">
                  <CardContent className="pt-6">
                    <div className="flex flex-col items-center text-center space-y-4">
                      <div className="p-4 bg-primary-light rounded-lg transition-all duration-200 hover:animate-pulse">
                        <Icon className="size-8 text-primary" strokeWidth={1.5} />
                      </div>
                      <CardTitle className="text-xl font-semibold text-white">
                        {service.title}
                      </CardTitle>
                      <CardDescription className="text-white leading-relaxed">
                        {service.description}
                      </CardDescription>
                      <Link to={service.link} className="text-white font-medium inline-flex items-center gap-1 hover:underline underline-offset-4 transition-all duration-200 mt-2">
                        Read More
                        <span aria-hidden="true">→</span>
                      </Link>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}